import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { StatisticsSummaryItem } from '@/summaryReport/summaryData.types';
import { Table } from '@/core/Table.atom';
import { SUMMARY_REPORT_STATS_PROPERTIES } from '@/summaryReport/summaryData.constants';
import { getPropertyItems } from '@/summaryReport/summaryReport.utilities';

export interface SummaryReportTableProps {
  items: StatisticsSummaryItem[];
  title?: string;
}

export const SummaryReportTable: React.FunctionComponent<SummaryReportTableProps> = ({ items, title }) => {
  const [sortProperty, setSortProperty] = useState('');
  const [sortAsc, setSortAsc] = useState(true);
  const [tableItems, setTableItems] = useState(
    SUMMARY_REPORT_STATS_PROPERTIES.map((property) => getPropertyItems(property, items)),
  );

  const sortItems =
    (sortAsString = false) =>
    (columnName: string, sortAscending: boolean) => {
      const sortedItems = _.orderBy(
        tableItems,
        [(item) => (sortAsString ? item[columnName] : item[columnName])], // Replace `toSortValue` with direct access or a valid function
        [sortAscending ? 'asc' : 'desc'],
      );

      setSortProperty(columnName);
      setSortAsc(!sortAscending);
      setTableItems(sortedItems);
    };

  useEffect(() => {
    setTableItems(SUMMARY_REPORT_STATS_PROPERTIES.map((property) => getPropertyItems(property, items)));
  }, [items]);

  const columns = [
    {
      accessor: 'statistic',
      cellStyle: {
        maxWidth: '70px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        alignItems: 'left' as const,
      },
      header: 'Statistic',
      sortable: true,
    },
    ...items.map((item) => ({
      accessor: item.name,
      cellStyle: {
        maxWidth: '70px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'right' as const,
      },
      header: item.name,
      sortable: true,
    })),
  ];

  return (
    <Table
      columns={columns}
      items={tableItems as any}
      sortProperty={sortProperty}
      sortAscending={sortAsc}
      sortTableCallback={sortItems()}
      headerClass="summaryReportTable"
    />
  );
};
